import { CustomButton, showToaster, toasterTypes } from '../../widgets'
import { Col, Row } from 'reactstrap'
import ModalComponent from '../common/Modal/modal'
import { FieldItem } from '../../widgets/fields';
import { AlertRulesElements } from './FormElements';
import useFieldItem from '../../widgets/fields/UseFieldItem';
import { useEffect, useMemo, useState } from 'react';
import { addAlertRule, getFormVariables, getRecordsUidFields, getRoles, updateAlertRule } from './apiController';
import { setLoading } from '../../store/slices/auth';
import { useDispatch } from 'react-redux';
import { cloneDeep, set } from 'lodash';
import { getProjectTeamList, getUsersList } from '../people/apiController';

interface DropDownValues {
    label: string;
    value: string;
    type?: string;
    key?: string;
    form_use_category?: string[];
    field_id?: string;
}

const CreateAlertRule = (props) => {
    const { projectData, onClose, forms, groupData, groups, isUpdate, previousState } = props;
    const [values, fields, handleChange, { validateValues, updateValue, updateError, removeErrors }] = useFieldItem(AlertRulesElements, {}, { onValueChange });
    const [formsValues, setFormsValues] = useState<DropDownValues[]>([]);
    const [formFieldsValues, setFormFieldsValues] = useState<DropDownValues[]>([]);
    const [targetRolesValues, setTargetRolesValues] = useState<DropDownValues[]>([]);
    const [targetUsersValues, setTargetUsersValues] = useState<DropDownValues[]>([]);
    const [targetFormValues, setTargetFormValues] = useState<DropDownValues[]>([]);
    const [targetFormUidFieldValues, setTargetFormUidFieldValues] = useState<DropDownValues[]>([]);
    const [isLoadingMore, setIsLoadingMore] = useState<boolean>(false);
    const dispatch = useDispatch();
    /**
     * create drop down values
     * @param data 
     * @param dataType 
     * @returns 
     */
    function createDropDownValues(data, dataType = "form") {
        let dropDownValues: DropDownValues[] = [];
        if (dataType === "form") {
            data.map((d, i) => {
                let Obj: DropDownValues = {
                    label: d.form_name.trim(),
                    value: d.id,
                    form_use_category: d.form_use_category || []
                }
                dropDownValues.push(Obj)
            }
            )
        }
        else if (dataType === "field") {
            data.map((d, i) => {
                let Obj: DropDownValues = {
                    label: d.field_name.trim(),
                    value: d.id,
                    type: d.field_type,
                }
                dropDownValues.push(Obj)
            })
        }
        else if (dataType === "uidField") {
            data.map((d, i) => {
                let Obj: DropDownValues = {
                    label: d.field_selected_value.trim(),
                    value: d.record_id,
                    field_id: d.field_id,
                }
                dropDownValues.push(Obj)
            })
        }
        return dropDownValues;
    }

    /**
     * get form drop down values
     */
    function getFormDropDownValues() {
        const formVals = createDropDownValues(forms, "form");
        setFormsValues(formVals);
        return { formVals };
    }

    /**
     * get form fields values
     */
    async function getFormFieldsValues(formId = null, formType: any = null) {

        let formFields: any[] = [];
        const response = await getFormVariables(formId);
        formFields = response?.data || [];
        const fieldValues = createDropDownValues(formFields, "field");
        setFormFieldsValues(fieldValues);
        updateValue({ formFields: null })
        return fieldValues;
    }

    /**
     * Initialize form with previous state if in update mode
     */
    async function initializeWithPreviousState() {
        if (!previousState || !isUpdate) return;

        try {
            const { formVals } = getFormDropDownValues();

            const formObj = formVals.find(form => form.value === previousState.form_id);
            if (!formObj) {
                console.error("Could not find form in dropdown values");
                return;
            }

            const fieldsList = await getFormFieldsValues(previousState.form_id);

            const fieldObj = fieldsList.find(field => field.value === previousState.field_ids?.[0]);
            if (!fieldObj) {
                console.error("Could not find fields in dropdown values");
                return;
            }

            // Helper to safely filter values
            const safeFilter = (list: any[], keys: any[]) => {
                if (!Array.isArray(list) || !Array.isArray(keys)) return [];
                return list.filter(item => keys.includes(item.value));
            };

            const safeFind = (list: any[], key: any) => {
                if (!Array.isArray(list)) return null;
                return list.find(item => item.value === key) || null;
            };

            const alertObj = safeFind(AlertRulesElements.alert.values, previousState.alert_type);

            const alertCategoryObjs = safeFilter(
                AlertRulesElements.alert_category.values,
                previousState.alert_category
            );

            const messageModeObjs = safeFilter(
                AlertRulesElements.message_mode.values,
                previousState.message_mode
            );

            const setNotificationObjs = safeFilter(
                AlertRulesElements.set_notification.values,
                previousState.set_notification
            );

            const setColourObj = safeFind(
                AlertRulesElements.set_colour.values,
                previousState.set_colour
            );

            const targetRolesObjs = safeFilter(
                targetRolesValues || [],
                previousState.target_roles || []
            );
            const UnfilteredtargetUsers: any = await getTargetRolesUsers(previousState.target_roles || [], true);
            let filteredTargetUsers = UnfilteredtargetUsers ? UnfilteredtargetUsers : [];
            if (previousState.target_users && previousState.target_users.length > 0) {
                filteredTargetUsers = filteredTargetUsers.filter(user =>
                    previousState.target_users.includes(user.value)
                );
            }
            const targetUidFormObj = safeFind(
                targetFormValues,
                previousState.target_uid_form
            );

            let targetFormUsersObjs: any[] = [];
            if (targetUidFormObj) {
                const targetFormFieldsValues = await getUidFormFieldsValues(previousState.target_uid_form);
                targetFormUsersObjs = safeFilter(
                    targetFormFieldsValues,
                    previousState.target_form_users
                );
            }

            updateValue({
                form: formObj,
                formFields: fieldObj,
                alert: alertObj,
                minValue: previousState.min_value ?? 0,
                maxValue: previousState.max_value ?? 0,
                alert_category: alertCategoryObjs,
                message_mode: messageModeObjs,
                set_notification: setNotificationObjs,
                set_colour: setColourObj,
                target_roles: targetRolesObjs,
                target_users: filteredTargetUsers,
                target_uid_form: targetUidFormObj,
                target_form_users: targetFormUsersObjs,
            });

        } catch (error) {
            console.error("Error in initializeWithPreviousState:", error);
        }
    }


    useEffect(() => {
        const loadData = async () => {
            await fetchInitialData();
        };
        loadData();
    }, [forms]);

    useEffect(() => {
        if (!previousState) return;

        if (isUpdate) {
            initializeWithPreviousState();
        } else {
            getFormDropDownValues();
        }
    }, [previousState, isUpdate, targetRolesValues, targetFormValues]);

    const fetchInitialData = async () => {
        dispatch(setLoading(true));
        try {
            const roles = await getRoles();
            const formattedRoles: DropDownValues[] = roles.data.map((role) => ({
                label: role.name,
                value: role.name,
                key: role.key
            }));
            setTargetRolesValues(formattedRoles);

            // const users = await getUsersList();

            const formValues = createDropDownValues(forms, "form");
            formValues.unshift({ label: "None", value: "null_value" });
            setTargetFormValues(formValues);
            getFormDropDownValues();
        } catch (error) {
            console.error("Error fetching initial data:", error);
            showToaster(toasterTypes.ERROR, "Error fetching initial data");
        } finally {
            dispatch(setLoading(false));
        }
    }

    /**
     * get target form uid form fields values
     */
    async function getUidFormFieldsValues(formId = null, pageNo = 1, perPage = 100) {
        try {
            setIsLoadingMore(true);
            const topicId = props?.projectData?.TopicID;
            const response = await getRecordsUidFields(topicId, formId, pageNo, perPage);
            const uidValues = createDropDownValues(response?.data || [], "uidField");
            setTargetFormUidFieldValues(uidValues);
            return uidValues;
        } catch (error) {
            console.error('Error fetching UID form field values:', error);
            return [];
        } finally {
            setIsLoadingMore(false);
        }
    }

    /**
    * on value change for form fields
    * @param name 
    * @param value 
    * @param values 
    * @param fieldValues 
    * @returns 
    */
    function onValueChange(name, value, values, fieldValues = null) {
        let resetValue = {};
        if (name === "form") {
            getFormFieldsValues(value?.value, name);
        }
        if (name === "target_uid_form") {
            if (value?.value === "null_value") {
                setTargetFormUidFieldValues([]);
                resetValue = { target_form_users: [] };
            } else {
                getUidFormFieldsValues(value?.value);
            }
        }
        if (name === "target_roles") {
            getTargetRolesUsers(value, false);
        }
        return [
            {
                ...values,
                ...resetValue,
                [name]: value,
            },
        ];
    }

    const fetchAndFilterTargetUsers = async (targetUserNums: string[]) => {
        if (!targetUserNums || targetUserNums.length === 0) return;

        try {
            dispatch(setLoading(true));

            const usersResponse = await getUsersList();
            const allUsers = usersResponse?.data || usersResponse?.users || [];

            const filteredUsers = allUsers.filter(user =>
                targetUserNums.includes(user.usernum)
            );

            const formattedUsers: DropDownValues[] = filteredUsers.map((user) => ({
                label: user.invitee_name || user.name || user.email,
                value: user.usernum,
            }));

            setTargetUsersValues(formattedUsers);
        } catch (error) {
            console.error("Error fetching target users:", error);
            showToaster(toasterTypes.ERROR, "Error fetching target users");
        } finally {
            dispatch(setLoading(false));
        }
    };

    const getTargetRolesUsers = async (selectedRoles, isReturnFiltered) => {
        try {
            dispatch(setLoading(true));
            let roles: any = [];
            if (isReturnFiltered) {
                roles = selectedRoles
            } else {
                roles = selectedRoles.map((role) => role.key);
            }

            let projectid: any = { projectid: props.projectData.id };

            const userPromises = roles.map((role) =>
                getProjectTeamList(projectid, 1, 100, "", "accepted", role.toLowerCase())
            );

            const usersResponses = await Promise.all(userPromises);

            const allUsers = usersResponses.flatMap(response => response?.users || []);

            const uniqueUsers = Array.from(
                new Map(allUsers.map(user => [user?.usernum, user])).values()
            );

            const formattedUsers: DropDownValues[] = uniqueUsers.map((user) => ({
                label: user.invitee_name,
                value: user.usernum,
            }));
            setTargetUsersValues(formattedUsers);
            return formattedUsers;
        } catch (error) {
            console.error("Error fetching users for selected roles:", error);
            showToaster(toasterTypes.ERROR, "Error fetching users for selected roles");
        } finally {
            dispatch(setLoading(false));
        }
    }

    function validateFieldTypes() {
        return values.formFields.type !== "number";
    }

    function parseValue(val: any): number | string {
        let fieldType = values.formFields.type;
        if (fieldType === "number") {
            return Number(val);
        } else {
            return String(val);
        }
    }

    async function submitAlertRules() {
        if (validateValues(["form", "formFields", "alert", "min_value"])) {
            showToaster(toasterTypes.ERROR, "Please enter the proper values in the fields highlighted in red");
            return;
        }

        let reqObj: any = {
            form_group_id: groupData.id,
            alert_type: values.alert?.value,
            field: [values.formFields?.label],
            field_ids: [values.formFields?.value],
            form_id: values.form?.value,
            topicid: projectData.TopicID,
            alert_category: values.alert_category?.map((item) => item.value) || [],
            message_mode: values.message_mode?.map((item) => item.value) || [],
            set_notification: values.set_notification?.map((item) => item.value) || [],
            set_colour: values.set_colour?.value || "",
            target_roles: values.target_roles?.map((item) => item.value) || [],
            target_users: values.target_users?.map((item) => item.value) || [],
            target_uid_form: (values.target_uid_form?.value === "null_value") ? "" : (values.target_uid_form?.value || ""),
            target_form_users: values.target_form_users?.map((item) => item.value) || [],
            project_id: projectData.id,
        }

        const minVal: number | string = parseValue(values?.minValue);
        if (values.minValue) {
            reqObj.min_value = minVal;
        }
        if (values.maxValue) {
            reqObj.max_value = Number(values?.maxValue);
        }
        if (isUpdate) {
            reqObj.id = previousState?.id || ""
        }

        dispatch(setLoading(true));
        try {
            let response: any;
            if (isUpdate) {
                response = await updateAlertRule(reqObj);
            } else {
                response = await addAlertRule(reqObj);
            }
            if (response.success) {
                showToaster(toasterTypes.SUCCESS, response?.message || `${isUpdate ? "Updated" : "Added"} Alert Rule`);
            }
            onClose();

        } catch (error) {
            showToaster(toasterTypes.ERROR, `Failed To ${isUpdate ? "Update" : "Add"} Alert Rule`);
        } finally {
            dispatch(setLoading(false));
        }
    }

    const isNotificationTypeSelected = (type: string) => {
        if (type == "set_color") {
            return values.set_notification?.some(item => item.value === "color");
        } else if (type == "communicate") {
            return values.set_notification?.some(item => item.value === "communicate");
        }
    }

    return (
        <ModalComponent
            width={"60%"}
            isOpen={true}
            onClose={() => onClose()}
            header={`${isUpdate ? "Update" : "Add"} Alert Rule`}
            centered={true}
            customClass='add-alert-rule-modal'
            body={
                <>
                    <Row>
                        <Col md={6}>
                            <FieldItem
                                {...AlertRulesElements.form}
                                value={values.form}
                                values={formsValues}
                                onChange={(...e) => handleChange(AlertRulesElements.form.name, ...e)}
                                touched={fields.form && fields.form.hasError}
                                error={fields.form && fields.form.errorMsg}
                            />
                        </Col>
                        <Col md={6}>
                            <FieldItem
                                {...AlertRulesElements.formFields}
                                value={values.formFields}
                                values={formFieldsValues}
                                onChange={(...e) => handleChange(AlertRulesElements.formFields.name, ...e)}
                                touched={fields.formFields && fields.formFields.hasError}
                                error={fields.formFields && fields.formFields.errorMsg}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FieldItem
                                {...AlertRulesElements.alert}
                                value={values.alert}
                                onChange={(...e) => handleChange(AlertRulesElements.alert.name, ...e)}
                                touched={fields.alert && fields.alert.hasError}
                                error={fields.alert && fields.alert.errorMsg}
                            />
                        </Col>
                    </Row>

                    {values.alert?.value === "thresholdRange" ?
                        (<>
                            <Row>
                                <Col md={6}>
                                    <FieldItem
                                        {...AlertRulesElements.minValue}
                                        value={values.minValue}
                                        onChange={(...e) => handleChange(AlertRulesElements.minValue.name, ...e)}
                                        touched={fields.minValue && fields.minValue.hasError}
                                        error={fields.minValue && fields.minValue.errorMsg}
                                    />
                                </Col>
                                <Col md={6}>
                                    <FieldItem
                                        {...AlertRulesElements.maxValue}
                                        value={values.maxValue}
                                        onChange={(...e) => handleChange(AlertRulesElements.maxValue.name, ...e)}
                                        touched={fields.maxValue && fields.maxValue.hasError}
                                        error={fields.maxValue && fields.maxValue.errorMsg}
                                    />
                                </Col>
                            </Row>
                        </>
                        ) : values.alert?.value !== "missing" && (
                            <Row>
                                <Col md={6}>
                                    <FieldItem
                                        {...AlertRulesElements.value}
                                        value={values.minValue}
                                        onChange={(...e) => handleChange(AlertRulesElements.minValue.name, ...e)}
                                        touched={fields.minValue && fields.minValue.hasError}
                                        error={fields.minValue && fields.minValue.errorMsg}
                                    />
                                </Col>
                            </Row>
                        )
                    }


                    <Row>
                        <Col md={6}>
                            <FieldItem
                                {...AlertRulesElements.set_notification}
                                value={values.set_notification}
                                onChange={(...e) => handleChange(AlertRulesElements.set_notification.name, ...e)}
                                touched={fields.set_notification && fields.set_notification.hasError}
                                error={fields.foset_notificationrm && fields.set_notification.errorMsg}
                            />
                        </Col>
                        {isNotificationTypeSelected("set_color") && <Col md={6}>
                            <FieldItem
                                {...AlertRulesElements.set_colour}
                                value={values.set_colour}
                                onChange={(...e) => handleChange(AlertRulesElements.set_colour.name, ...e)}
                                touched={fields.set_colour && fields.set_colour.hasError}
                                error={fields.set_colour && fields.set_colour.errorMsg}
                            />
                        </Col>}
                    </Row>

                    {isNotificationTypeSelected("communicate") && <>
                        <Row>
                            <Col md={6}>
                                <FieldItem
                                    {...AlertRulesElements.alert_category}
                                    value={values.alert_category}
                                    onChange={(...e) => handleChange(AlertRulesElements.alert_category.name, ...e)}
                                    touched={fields.alert_category && fields.alert_category.hasError}
                                    error={fields.alert_category && fields.alert_category.errorMsg}
                                />
                            </Col>
                            <Col md={6}>
                                <FieldItem
                                    {...AlertRulesElements.message_mode}
                                    value={values.message_mode}
                                    onChange={(...e) => handleChange(AlertRulesElements.message_mode.name, ...e)}
                                    touched={fields.message_mode && fields.message_mode.hasError}
                                    error={fields.message_mode && fields.message_mode.errorMsg}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FieldItem
                                    {...AlertRulesElements.target_roles}
                                    value={values.target_roles}
                                    values={targetRolesValues}
                                    onChange={(...e) => handleChange(AlertRulesElements.target_roles.name, ...e)}
                                    touched={fields.target_roles && fields.target_roles.hasError}
                                    error={fields.target_roles && fields.target_roles.errorMsg}
                                />
                            </Col>
                            <Col md={6}>
                                <FieldItem
                                    {...AlertRulesElements.target_users}
                                    value={values.target_users}
                                    values={targetUsersValues}
                                    onChange={(...e) => handleChange(AlertRulesElements.target_users.name, ...e)}
                                    touched={fields.target_users && fields.target_users.hasError}
                                    error={fields.target_users && fields.target_users.errorMsg}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FieldItem
                                    {...AlertRulesElements.target_uid_form}
                                    value={values.target_uid_form}
                                    values={targetFormValues}
                                    onChange={(...e) => handleChange(AlertRulesElements.target_uid_form.name, ...e)}
                                    touched={fields.target_uid_form && fields.target_uid_form.hasError}
                                    error={fields.target_uid_form && fields.target_uid_form.errorMsg}
                                />
                            </Col>
                            <Col md={6}>
                                <FieldItem
                                    {...AlertRulesElements.target_form_users}
                                    value={values.target_form_users}
                                    values={targetFormUidFieldValues}
                                    onChange={(...e) => handleChange(AlertRulesElements.target_form_users.name, ...e)}
                                    handleMenuScrollToBottom={() => {
                                        const nextPage = Math.floor(targetFormUidFieldValues.length / 100) + 1;
                                        getUidFormFieldsValues(values.target_uid_form?.value, nextPage, 100);
                                    }}
                                    isLoadingMore={isLoadingMore}
                                    touched={fields.target_form_users && fields.target_form_users.hasError}
                                    error={fields.target_form_users && fields.target_form_users.errorMsg}
                                />
                            </Col>
                        </Row>
                    </>
                    }
                </>
            }
            footer={
                <CustomButton
                    type="primary"
                    isDisabled={false}
                    text={`${isUpdate ? "Update" : "Add"}`}
                    onClick={() => submitAlertRules()}
                ></CustomButton>
            }
        />
    )
}

export default CreateAlertRule